<div class="container" [formGroup]="filterForm">
    <!--  -->
    <input mat-input formControlName="inputFilter" type="text" (keyup)="onKeyUp($event)">
    <div class="container-checks">
        <mat-checkbox checked="true" (change)="SelectAll()">Select All</mat-checkbox>
        <mat-checkbox class="check" *ngFor="let filter of filteredFilterValues | async" [checked]="allComplete" >
            {{filter.value}}
            <!-- *ngIf="column.nombre == CHECK_BOX_COLUMN_NAME"
        (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()" -->
    </mat-checkbox>
    </div>
</div>